import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { KeyFunctionPageComponent } from "./key-function-page.component";

export const keyFunctionPageRoute = new OrganisationPageRouteBuilder<{ keyFunctionId: number }>()
    .usingNgComponent("adapt-key-function-page", KeyFunctionPageComponent)
    .atOrganisationUrl("/key-functions/:keyFunctionId")
    .reloadOnSearch(false)
    .withTitle("Key Function")
    .build();
